export const ENDPOINTS = {
  CREATE_ANALYSIS: 'target/project',
  FIRST_STEP: 'target/data/first_step',
  SECOND_STEP: 'target/data/second_step',
  RESULT: 'target/data/result',
}
